var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCcw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.5C2 2.94772 2.44772 2.5 3 2.5C3.55228 2.5 4 2.94772 4 3.5V6.64371C4.84614 5.82788 5.74982 4.99767 6.725 4.31051C8.19885 3.27197 9.91151 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5C22 18.0228 17.5228 22.5 12 22.5C7.64437 22.5 3.94159 19.7159 2.56928 15.8332C2.38523 15.3125 2.65816 14.7412 3.17887 14.5572C3.69959 14.3731 4.27091 14.646 4.45496 15.1668C5.55366 18.2753 8.51831 20.5 12 20.5C16.4183 20.5 20 16.9183 20 12.5C20 8.08172 16.4183 4.5 12 4.5C10.4456 4.5 9.12901 5.06319 7.87701 5.9454C7.03861 6.53618 6.26292 7.24327 5.47581 8H8.5C9.05228 8 9.5 8.44772 9.5 9C9.5 9.55228 9.05228 10 8.5 10H3C2.44772 10 2 9.55228 2 9V3.5Z",
    fill: "#03071275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCcw);
export default __webpack_public_path__ + "static/media/arrow-ccw.68cac767bd3b0189882749593005a68f.svg";
export { ForwardRef as ReactComponent };